import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import StockLineChart13F from "../chart/StockLineChart13F";
import StockLineChartInsider from "../chart/StockLineChartInsider";
import StockBarChart from "../chart/StockBarChart";
import StockIncomeChart from "../sections/StockIncomeChart";
import BalanceSheetChart from "./BalanceSheetChart";
import CashFlow from "./CashFlow";

export default function StockChartSection({ ticker: propTicker, companykor, chartSelection, activeMainTab }) {
  const { ticker: urlTicker } = useParams();
  const ticker = propTicker || urlTicker;
  const [chartLabels, setChartLabels] = useState([]);

  if (activeMainTab === "income") {
    return (
      <Card className="h-100 shadow-sm border-0">
        <Card.Body className="d-flex flex-column h-100 px-0">
          <div className="d-flex justify-content-between align-items-center mb-2 px-3">
            <h4 className="fw-bold m-0 text-dark">손익계산서</h4>
          </div>
          <div className="w-100 flex-grow-1" style={{ minHeight: "300px" }}>
            <StockIncomeChart ticker={ticker} />
          </div>
        </Card.Body>
      </Card>
    );
  }
  if (activeMainTab === "balance") {
    return (
      <Card className="h-100 shadow-sm border-0">
        <Card.Body className="d-flex flex-column h-100 px-0">
          <div className="d-flex justify-content-between align-items-center mb-2 px-3">
            <h4 className="fw-bold m-0 text-dark">재무상태표</h4>
          </div>
          <div className="w-100 flex-grow-1" style={{ minHeight: "300px" }}>
            <BalanceSheetChart ticker={ticker} />
          </div>
        </Card.Body>
      </Card>
    );
  }

  if (activeMainTab === "cashflow") {
    return (
      <Card className="h-100 shadow-sm border-0">
        <Card.Body className="d-flex flex-column h-100 px-0">
          <div className="d-flex justify-content-between align-items-center mb-2 px-3">
            <h4 className="fw-bold m-0 text-dark">현금흐름표</h4>
          </div>
          <div className="w-100 flex-grow-1" style={{ minHeight: "300px" }}>
            <CashFlow ticker={ticker} />
          </div>
        </Card.Body>
      </Card>
    );
  }

  const isInsiderTab = activeMainTab === "insider";
  const is13FTab = activeMainTab === "13f";

  return (
    <Card className="h-100 shadow-sm border-0">
      <Card.Body className="d-flex flex-column px-0">
        <div className="d-flex justify-content-between align-items-center mb-2 px-3">
          <h4 className="fw-bold m-0 text-dark">
            {isInsiderTab ? "내부자 거래 내역" : "주가차트"}
          </h4>
        </div>

        {/* 라인 차트 영역 */}
        <div className="w-100" style={{ flex: 1, minHeight: "300px" }}>
          {isInsiderTab ? (
            <StockLineChartInsider
              ticker={ticker}
              companykor={companykor}
              onDataLoad={setChartLabels}
              chartSelection={chartSelection}
            />
          ) : (
            <StockLineChart13F
              ticker={ticker}
              companykor={companykor}
              onDataLoad={setChartLabels}
              chartSelection={chartSelection}
            />
          )}
        </div>

        {is13FTab && (
          <>
            <div className="mt-2 px-3">
              <h5 className="fw-bold m-0 text-dark">
                보유액 / 거래액 차트
              </h5>
            </div>

            {/* 바 차트 영역 */}
            <div className="w-100" style={{ height: "200px"}}>
              {chartSelection ? (
                <StockBarChart chartLabels={chartLabels} chartSelection={chartSelection} />
              ) : (
                <div className="d-flex align-items-center justify-content-center text-muted border border-secondary border-dashed h-100 mx-3" style={{ borderStyle: "dashed", opacity: 0.5, fontSize: "14px" }}>
                  인물/기관 정보를 선택하면 보유액 추이가 표시됩니다.
                </div>
              )}
            </div>
          </>
        )}
      </Card.Body>
    </Card>
  );
}
